import { Button, Input } from 'reactstrap'
import { useInputValue } from '../hooks/useInputValue'
import { FightData } from '../redux/models'

type HeaderProps = {
    fightData: FightData
    storedFights: FightData[]

    commitFightName: (name: string) => void
    selectFightToEdit: (ev: any) => void
    commitFightEdits: () => void
    createNewFight: () => void
    cloneFight: () => void
    deleteFight: () => void

    importFight: () => void
    exportFight: () => void
}

export const Header = (props: HeaderProps): JSX.Element | null => {

    const fightNameInputs = useInputValue({
        initialValue: props.fightData.fight.name
    })

    return (
        <>
            <Input
                bsSize="sm"
                type="text"
                className="flex-grow-1"
                value={fightNameInputs.value}
                onChange={fightNameInputs.onChange}
                onBlur={() => {
                    props.commitFightName(`${fightNameInputs.value}`)
                }}
            />

            <Input
                bsSize="sm"
                type="select"
                className="flex-grow-1"
                onChange={props.selectFightToEdit}
                value={props.fightData.fight.id}
            >
                {props.storedFights.map(fightData => (
                    <option key={fightData.fight.id} value={fightData.fight.id}>
                        {fightData.fight.name}
                    </option>
                ))}
            </Input>
            <Button
                color="success"
                size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.commitFightEdits}
            >
                {"Save"}
            </Button>
            <Button size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.createNewFight}
            >
                {"Create new"}
            </Button>
            <Button size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.importFight}
            >
                {"Import"}
            </Button>
            <Button size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.exportFight}
            >
                {"Export"}
            </Button>
            <Button size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.cloneFight}
            >
                {"Clone"}
            </Button>
            <Button
                color="danger"
                size="sm"
                className="flex-shrink-0"
                style={{ minWidth: 75 }}
                onClick={props.deleteFight}
            >
                {"Delete"}
            </Button>
        </>
    )
}
